module.exports = __webpack_public_path__ + "img/standardFinancePic.8c179402.png";